<div class="min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">

  <div class="grid grid-cols-1 grid-flow-row gap-4 w-full md:mx-auto py-6" *ngIf="assets">
      <div class="relative w-full">
        <image-slider [images]="filter(assets)" [autoPlaySpeed]="20000" [aspectClass]="'1088/1632'"></image-slider>
      </div>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>
</div>

